var exports = {
  "v": "NewViewGraphicContainer__c3rIxH",
};

module.exports = exports;
